import {
  NOTIFICATION_STATUSES,
  useNotifications,
} from "@adsk/alloy-react-notification";
import { useTranslations } from "@adsk/acc-issues-translations";
import { useCallback } from "react";

export const usePlacementHandlers = (
  setIsLoading: (isLoading: boolean) => void
) => {
  const { showNotification } = useNotifications();
  const { T } = useTranslations();

  const onPlacementEnd = useCallback(
    ({ message, isSuccess }: { message: string; isSuccess: boolean }) => {
      showNotification({
        status: isSuccess
          ? NOTIFICATION_STATUSES.SUCCESS
          : NOTIFICATION_STATUSES.ERROR,
        message,
      });
      setIsLoading(false);
    },
    [showNotification, setIsLoading]
  );

  const onPlacementSuccess = useCallback(
    ({ isSheet, isAdd }: { isSheet: boolean; isAdd: boolean }) => {
      const action = isAdd ? "add" : "remove";
      const message = isSheet
        ? T.translate(`issueEditForm.placement.${action}.sheetSuccess`)
        : T.translate(`issueEditForm.placement.${action}.documentSuccess`);
      onPlacementEnd({ message: message as string, isSuccess: true });
    },
    [T, onPlacementEnd]
  );

  const onPlacementFailure = useCallback(
    ({ isSheet, isAdd }: { isSheet: boolean; isAdd: boolean }) => {
      const action = isAdd ? "add" : "remove";
      const message = isSheet
        ? T.translate(`issueEditForm.placement.${action}.sheetFailure`)
        : T.translate(`issueEditForm.placement.${action}.documentFailure`);
      onPlacementEnd({ message: message as string, isSuccess: false });
    },
    [T, onPlacementEnd]
  );

  return {
    onPlacementSuccess,
    onPlacementFailure,
  };
};
